export default "__VITE_ASSET__BC8iQr$t__"